import { Flex } from 'components/Flex';
import { useFetchJaneByIdDataContext } from 'modals/JaneDetailsModal/FetchJaneById.data.context';
import { JaneName } from 'modals/JaneDetailsModal/views/JaneDetailsView/ReviewsTab/ReviewsTab.styled';
import {
  ColorDot,
  TimeWrapper,
  FlexWrapper,
  ActivityContentWrapper,
  TextWrapper,
} from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/ActivityTab/ActivityTab.styled';
import { Fragment, FC } from 'react';
import { SectionDivider } from 'modals/ShiftModal/ShiftModal.styled';
import { humanReadableDate } from 'modals/JaneDetailsModal/JaneDetailsModal.constants';
import {
  LoadingWrapper,
  Text,
} from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/GeneralTab/GeneralTab.styled';
import {
  Activity,
  auditEvents,
  getActivityColorByEvent,
} from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/JaneModal/JaneDetailsView/ActivityTab/ActivityTab.types';
import i18next from 'i18next';
import { BKJLoadingSpinner } from '@bookjane2/bookjane-design-library';
import { useSelector } from 'react-redux';
import isUserTimeFormat24hSelector from 'store/selectors/userSelectors/isUserTimeFormat24hSelector';

export const ActivityTab: FC = () => {
  const { data, activities } = useFetchJaneByIdDataContext();
  const isUserTimeFormat24h = useSelector(isUserTimeFormat24hSelector);
  if (!data)
    return (
      <LoadingWrapper>
        <BKJLoadingSpinner variant="Default" />
      </LoadingWrapper>
    );
  const { shorthandName = '' } = data;
  return (
    <Fragment>
      <FlexWrapper>
        <Flex flexDirection="column" width="100%">
          <JaneName>{shorthandName}</JaneName>
          <SectionDivider variant="Thin" />
        </Flex>
        <Flex flexDirection="column" width="100%" gap="32px">
          {activities?.length > 0 ? (
            activities.map((item: Activity) => (
              <ActivityContentWrapper key={item.id}>
                <TimeWrapper>
                  {humanReadableDate(item?.created_at, undefined, isUserTimeFormat24h)}
                </TimeWrapper>
                <Flex gap="6px" width="100%">
                  <ColorDot color={getActivityColorByEvent(item?.event)}>•</ColorDot>
                  <TextWrapper>
                    {auditEvents(item?.event, item?.feedable?.shift_ids[0])}
                  </TextWrapper>
                </Flex>
              </ActivityContentWrapper>
            ))
          ) : (
            <Flex height="581px" justifyContent="center" alignItems="center">
              <Text>{i18next.t('team_member:THERE_IS_NO_ACTIVITY')}</Text>
            </Flex>
          )}
        </Flex>
      </FlexWrapper>
    </Fragment>
  );
};
